import Wrapper from "../../../layout/Wrapper";
import CustomerReportComponent from "../../../screens/reports/customer";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Customer Report",
	description: "",
};

export default function CustomerReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CustomerReportComponent />
		</Wrapper>
	);
}